import { useState } from 'react';

const INVALID_INVITE_CODE = {
  error_code: 'E14004',
  message: 'Invalid Invite code'
};

const useInviteCode = ({ enroll }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inviteCode, setInviteCode] = useState('');
  const [error, setError] = useState({});
  const onInviteCodeChange = (e) => {
    setInviteCode(e.target.value);
  };
  const onEnroll = () => {
    setIsSubmitting(true);
    enroll(inviteCode).then((res) => {
      setError(res?.error || {});
      setIsSubmitting(false);
    });
  };
  return {
    inviteCode,
    onInviteCodeChange,
    error,
    isSubmitting,
    onEnroll,
    INVALID_INVITE_CODE,
    isEnrollButtonEnabled: inviteCode && !isSubmitting
  };
};

export default useInviteCode;
